/* eslint-disable */
import React, {
  useContext,
  useRef,
  useState,
  useEffect
} from 'react'
import PropTypes from 'prop-types'

import {
  VFScreen,
  Icon,
  VFText,
  VFInput,
} from '@vfgroup-oneplatform/foundation/Components'

import { View, FlatList, TouchableOpacity, SafeAreaView, Platform, Dimensions } from 'react-native'

import { Images } from '../../Themes'

import styles from './Search.Styles.js'
import RoamingContext from '../../Context'

const Search = ({
  // props below when the search is narrowed for specific locations or user types
  specificCountries,
  specificTitle,
  specificDescription,
  specificImage
}) => {
  // Info needed for this screen:
  // List of countries (code, value, image)

  const { onClose, theme, countriesList, setSelectedCountry: countryChanger, selectedCountry: selectedCountryInfo, setScreen: screenStateChange } = useContext(RoamingContext).roamingState

  let countries = countriesList

  // If we are showing a subset of countries we set the countries like this
  specificCountries ? (countries = specificCountries) : null

  const [country, setCountry] = useState('')
  const [selectedCountry, setSelectedCountry] = useState(selectedCountryInfo.name || '')


  // This is the countries that are displayed in the list (all countries or filtered ones)
  const [data, setData] = useState(countries?.countriesAlb || [])
  const searchRef = useRef()

  useEffect(() => {
    const pattern = new RegExp(country.normalize("NFD").replace(/[\u0300-\u036f]/g, ""), "gi");

    setData(countries?.countriesAlb?.filter(item => item.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").match(pattern)))
  }, [country])

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <>
        <VFScreen
          title="roaming_screen_title"
          onClose={onClose}
          showBack
          onBack={() => screenStateChange({ screen: 'HOME' })}
        >
          <View style={[styles.background(theme), { paddingHorizontal: '10%' }]}>
            <VFInput
              ref={searchRef}
              label={'roaming_search_country'}
              value={country}
              onChangeText={setCountry}
              labelTextStyle={styles.inputText}
              textColor={theme.isDark ? 'rgba(255, 255, 255, 1)' : 'rgba(102, 102, 102, 1)'}
              tintColor={theme.isDark ? 'rgba(255, 255, 255, 1)' : 'rgba(102, 102, 102, 1)'}
              baseColor={theme.isDark ? 'rgba(255, 255, 255, 1)' : 'rgba(102, 102, 102, 1)'}
            />

            <div style={{ display: 'flex', flexDirection: 'column', height: '60%', overflow: 'scroll' }}>
              {data?.map((item) => {
                return (
                  <TouchableOpacity
                    onPress={() => {
                      setSelectedCountry(item.name),
                        countryChanger(item),
                        screenStateChange({ screen: 'COUNTRY_ROAMING' })
                    }}
                  >
                    <View
                      style={
                        selectedCountry === item.name
                          ? styles.selectedBackground(theme)
                          : styles.countryContainer(theme)
                      }
                    >
                      <View style={styles.country}>
                        <Icon
                          style={styles.marginRight30}
                          name={
                            Images[item.id]
                              ? Images[item.id]
                              : Images.defaultFlag
                          }
                          type="image"
                          resizeMode="contain"
                          size={32}
                        />

                        <VFText
                          i18nKey={item.name}
                          style={styles.countryText}
                        />
                      </View>

                      <View>
                        {/* Add the tick below */}
                        {selectedCountry === item.name && (
                          <Icon
                            name={Images.countrySelect}
                            type="image"
                            resizeMode="contain"
                            size={24}
                          />
                        )}
                      </View>
                    </View>
                  </TouchableOpacity>
                )
              })}
            </div>

            {/* <FlatList
              data={Array.isArray(data) ? data : []}
              keyExtractor={item => item.name}
              renderItem={({ item }) => {
                
              }}
              contentContainerStyle={styles.countriesContainer}
              initialNumToRender={15}
            /> */}
          </View>
        </VFScreen>
      </>
    )
  }

  return (
    <>
      <VFScreen
        title="roaming_screen_title"
        onClose={onClose}
        showBack
        onBack={() => screenStateChange({ screen: 'HOME' })}
      >
        <View style={styles.background(theme)}>
          <VFInput
            ref={searchRef}
            label={'roaming_search_country'}
            value={country}
            onChangeText={setCountry}
            labelTextStyle={styles.inputText}
            textColor={theme.isDark ? 'rgba(255, 255, 255, 1)' : 'rgba(102, 102, 102, 1)'}
            tintColor={theme.isDark ? 'rgba(255, 255, 255, 1)' : 'rgba(102, 102, 102, 1)'}
            baseColor={theme.isDark ? 'rgba(255, 255, 255, 1)' : 'rgba(102, 102, 102, 1)'}
          />

          <FlatList
            data={Array.isArray(data) ? data : []}
            keyExtractor={item => item.name}
            renderItem={({ item }) => {
              return (
                <TouchableOpacity
                  onPress={() => {
                    setSelectedCountry(item.name),
                      countryChanger(item),
                      screenStateChange({ screen: 'COUNTRY_ROAMING' })
                  }}
                >
                  <View
                    style={
                      selectedCountry === item.name
                        ? styles.selectedBackground(theme)
                        : styles.countryContainer(theme)
                    }
                  >
                    <View style={styles.country}>
                      <Icon
                        style={styles.marginRight30}
                        name={
                          Images[item.id]
                            ? Images[item.id]
                            : Images.defaultFlag
                        }
                        type="image"
                        resizeMode="contain"
                        size={32}
                      />

                      <VFText
                        i18nKey={item.name}
                        style={styles.countryText}
                      />
                    </View>

                    <View>
                      {/* Add the tick below */}
                      {selectedCountry === item.name && (
                        <Icon
                          name={Images.countrySelect}
                          type="image"
                          resizeMode="contain"
                          size={24}
                        />
                      )}
                    </View>
                  </View>
                </TouchableOpacity>
              )
            }}
            contentContainerStyle={styles.countriesContainer}
            initialNumToRender={15}
          />
        </View>
      </VFScreen>
    </>
  )
}

Search.defaultProps = {}

Search.propTypes = {
  onClose: PropTypes.func,
  screenStateChange: PropTypes.func,
  countryChanger: PropTypes.func,
  selectedCountryInfo: PropTypes.object
}

export default Search
